/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Image from 'next/image';
import styles from '../styles.module.scss';
import parse from 'html-react-parser';
import { LANDING_PAGE_DATA } from '../config';
import { useViewport } from 'src/common/utils/responsive';
import { ModalDesktop, ModalMobile } from '@acko-tech/building-blocks.ui.modal';
import { ASSETS, COMPLIANCE_PENDING_ICONS } from 'src/common/utils/config';
import CrossIcon from 'src/international-insurance/components/bundled-plan/assets/cross';
import Button from 'src/common/components/button';
import { TravelInsuranceViewEvents } from 'src/common/utils/segment/types';

const Index = ({ sendCustomEvent }) => {
  const { isMobile } = useViewport();
  const [openModal, setOpenModal] = useState(false);
  const { usp_section, comparison_section } = LANDING_PAGE_DATA;

  const renderComparisonModal = () => {
    const { isMobile } = useViewport();
    const Modal: any = isMobile ? ModalMobile : ModalDesktop;

    return (
      <Modal
        show={openModal}
        onHide={() => setOpenModal(false)}
        wrapperStyles={`border-radius: 24px 24px 0px 0px;`}
        showOverlayBackground={true}
        urlhash=""
        header={
          <div className={styles.modalTitle}>{comparison_section.title}</div>
        }
        hideCloseButton
        padding={'32px 28px 20px 28px'}
        minWidth={isMobile ? '' : '400px'}
      >
        <div className={styles.comparisonModal}>
          {comparison_section?.list?.map((item, i) => {
            const isFirst = i === 0;
            const isLast = i === comparison_section?.list?.length - 1;
            return (
              <div key={i} className={styles.listItem}>
                <div className={styles.title}>{item}</div>
                <div className={styles.statsContainer}>
                  <div
                    className={styles.ackoStats}
                    style={{
                      borderRadius: isFirst
                        ? '10px 0 0 0'
                        : isLast
                        ? '0 0 0 10px'
                        : '',
                      borderTop: isFirst ? '1px solid rgb(239, 233, 251)' : '',
                      borderBottom: isLast
                        ? '1px solid rgb(239, 233, 251)'
                        : '',
                    }}
                  >
                    <Image
                      src={COMPLIANCE_PENDING_ICONS.TICK_STAGE}
                      height={'18px'}
                      width={'18px'}
                    />
                    {isFirst && (
                      <div className={styles.ackoLogo}>
                        <img
                          src={ASSETS.ACKO_LOGO_DARK}
                          width={'70px'}
                          height={'auto'}
                          alt="acko-logo"
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className={styles.otherStats}
                    style={{
                      borderRadius: isFirst
                        ? '0 10px 0 0'
                        : isLast
                        ? '0 0 10px 0'
                        : '',
                      borderTop: isFirst ? '1px solid rgb(224, 224, 232)' : '',
                      borderBottom: isLast
                        ? '1px solid rgb(224, 224, 232)'
                        : '',
                    }}
                  >
                    <CrossIcon color={'#040222'} />
                    {isFirst && (
                      <div className={styles.otherTag}>{'Others'}</div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.modalButton}>
          <Button
            marginTop="24px"
            handleClick={() => {
              setOpenModal(false);
            }}
            label={comparison_section?.button_text}
          />
        </div>
      </Modal>
    );
  };

  return (
    <section className={styles.uspSection}>
      <div className={styles.sectionTitle}>
        {parse(isMobile ? usp_section?.title : usp_section?.desktop_title)}
      </div>
      <div className={styles.uspCards}>
        {usp_section?.cards?.map(({ icon_url, title, subtitle }) => (
          <div key={title} className={styles.uspCard}>
            <Image src={icon_url} height={'60px'} width={'60px'} />
            <div className={styles.cardTitle}>{title}</div>
            <div className={styles.cardSubtitle}>{subtitle}</div>
          </div>
        ))}
      </div>
      <div
        className={styles.seeMoreAction}
        onClick={() => {
          setOpenModal(true);
          sendCustomEvent(
            {},
            TravelInsuranceViewEvents.VIEW_OTHER_PLANS_COMPARISON
          );
        }}
      >
        {usp_section?.see_more_text}
      </div>
      <div className={styles.comparisonSection}>{renderComparisonModal()}</div>
    </section>
  );
};

export default Index;
